/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceGamificationConfig
 */
export interface SurfaceGamificationConfig {
    /**
     * ID of the GamificationModel to render
     * @type {string}
     * @memberof SurfaceGamificationConfig
     */
    gamificationModelId?: string;
    /**
     * How to render the gamification model. Default full.
     * @type {string}
     * @memberof SurfaceGamificationConfig
     */
    displayMode?: SurfaceGamificationConfigDisplayModeEnum;
    /**
     * DENORMALIZED, READ-ONLY — the referenced GamificationModel's type (a GamificationType value), resolved by the serving route so the surface can place the block without a per-block fetch. Never stored; ignored on write.
     * @type {string}
     * @memberof SurfaceGamificationConfig
     */
    gamificationType?: string;
}


/**
 * @export
 */
export const SurfaceGamificationConfigDisplayModeEnum = {
    full: 'full',
    compact: 'compact',
    micro: 'micro',
    overlay: 'overlay'
} as const;
export type SurfaceGamificationConfigDisplayModeEnum = typeof SurfaceGamificationConfigDisplayModeEnum[keyof typeof SurfaceGamificationConfigDisplayModeEnum];


/**
 * Check if a given object implements the SurfaceGamificationConfig interface.
 */
export function instanceOfSurfaceGamificationConfig(value: object): value is SurfaceGamificationConfig {
    return true;
}

export function SurfaceGamificationConfigFromJSON(json: any): SurfaceGamificationConfig {
    return SurfaceGamificationConfigFromJSONTyped(json, false);
}

export function SurfaceGamificationConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceGamificationConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'gamificationModelId': json['gamificationModelId'] == null ? undefined : json['gamificationModelId'],
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'gamificationType': json['gamificationType'] == null ? undefined : json['gamificationType'],
    };
}

export function SurfaceGamificationConfigToJSON(json: any): SurfaceGamificationConfig {
    return SurfaceGamificationConfigToJSONTyped(json, false);
}

export function SurfaceGamificationConfigToJSONTyped(value?: SurfaceGamificationConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gamificationModelId': value['gamificationModelId'],
        'displayMode': value['displayMode'],
        'gamificationType': value['gamificationType'],
    };
}

